/* eslint-disable react-hooks/rules-of-hooks */
import {useWalletsState} from 'app/store/wallets/state';

export const selectWalletsData = () => useWalletsState((state) => state.wallets);
export const selectIsLoadingWallets = () => useWalletsState((state) => state.isLoading);
export const selectDefaultWallet = () => useWalletsState((state) => {
    if(!state.wallets && !state.wallets.length) return null
    return state.wallets.find(wallet => wallet.is_default === 1) || state.wallets[0]
});